import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { SecretsManagerService } from '../../service';

export type UnusedSecretsConfig = typeof UnusedSecretsConfig._.Config;

export const UnusedSecretsConfig = IntegrationConfig.make({
  service: SecretsManagerService,
  name: Integration_Handler_Names_Enum.UnusedSecrets,
  configSchema: z.object({
    allowedUnusedDays: z.number().min(1).max(365),
    secretPatternFilter: patternFilterSchema.optional(),
  }),
});
